const measure = (stack) => {
  stack.style.setProperty('--drv-amain-stack-h', `${stack.offsetHeight}px`);
};

const shown = (el) => !!el && el.getClientRects().length > 0;

const syncToc = (toc) => {
  toc.querySelectorAll('a[href^="#"]').forEach((link) => {
    const item = link.closest('li');
    if (!item) return;
    const id = decodeURIComponent(link.getAttribute('href').slice(1));
    item.hidden = !shown(document.getElementById(id));
  });
  toc.querySelectorAll('.drv-toc__l2').forEach((list) => {
    list.hidden = !list.querySelector(':scope > li:not([hidden])');
  });
  toc.querySelectorAll('.drv-toc__l1').forEach((item) => {
    const own = item.querySelector(':scope > a');
    if (!own) item.hidden = !item.querySelector('.drv-toc__l2:not([hidden])');
  });
};

let tocFrame = 0;
const syncTocs = () => {
  cancelAnimationFrame(tocFrame);
  tocFrame = requestAnimationFrame(() => document.querySelectorAll('.drv-toc').forEach(syncToc));
};

const init = () => {
  document.querySelectorAll('[data-drv-stack]').forEach((stack) => {
    if (stack.dataset.drvStackReady) return;
    stack.dataset.drvStackReady = '1';
    measure(stack);
    if ('ResizeObserver' in window) new ResizeObserver(() => measure(stack)).observe(stack);
  });
  syncTocs();
};

window.addEventListener('resize', syncTocs);

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init, { once: true });
} else {
  init();
}
document.addEventListener('shopify:section:load', init);
